import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModuleMobi } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettingsComponent } from './app-settings.component';



@NgModule({
  declarations: [AppSettingsComponent],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [AppSettingsComponent]
})
export class appSettingsModule { }
